module.exports = __webpack_public_path__ + "static/media/21-15.c8648da7.mp3";